var $1e23c5f7762fe734$exports = {};
$1e23c5f7762fe734$exports = {
    "pending": `pendiente`
};


export {$1e23c5f7762fe734$exports as default};
//# sourceMappingURL=es-ES.mjs.map
